import logo from './logo.svg';
import './App.css';
import {useState} from "react";
import {Route, Link, Routes, useParams, NavLink, useLocation} from 'react-router-dom';
import Grid from "./Grid.js";
import Single from "./Single.js";
import Info from "./Info.js";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
var art_projects = [
  {"title": "lifetime.systems", "thumb":"img/lifetime-thumb.png", "desc":"", "slug":"lf", "size":40},
  {"title": "postBreeder", "thumb":"img/PB-SQUARE.png", "desc":"", "slug":"pb", "size":30},
  {"title": "WestHollywood 2.0", "thumb":"img/DSCF0951.jpg", "desc":"", "slug":"wh2"},
  {"title": "WestHollywood 1.0", "thumb":"img/wh_thumb.png", "desc":"", "slug":"wh1"},
  {"title": "Screening Fitness", "thumb":"img/sf.png", "desc":"", "slug":"sf"},
  {"title": "Pangea", "thumb":"img/pangea-scaled.jpeg", "desc":"", "slug":"pangea"},
  {"title": "MR Sledge 001", "thumb":"img/pangea-scaled.jpeg", "desc":"", "slug":"mrsl001"}
  ];
  var client = [
      {"title": "Metaverse Landscapes", "thumb":"", "desc":""},
      {"title": "Kote Magasin Website", "thumb":"", "desc":""},
      {"title": "Kunsthalle Baden-Baden", "thumb":"", "desc":""}
  ];
function App() {
  const [workType, setWorkType] = useState("art");
  const location = useLocation();

  return (
    <div className="App">
    <div className="bar">
      <div className="title">Jakob Sitter</div>
      <div className="item"><NavLink to="/">Projects</NavLink></div>
    </div>
    <Routes>
        <Route path="/" element={ <Grid type={"art"}/> } />
        <Route path="/client" element={ <Grid type={"client"}/> } />
        <Route path="/work/:workId" element={ <Single />} />
        <Route path="/info" element={ <Info />} />
      </Routes>

    </div>
  );
}

export default App;
